import React from 'react';
import './timetable.scss';
import {Logout,SevenDaysFormatted, TodayFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import { useState, useEffect, useCallback} from "react";
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Format,
  Column,
  Button,
  //Pager,
  //Paging,
  Popup,
  Form,
  HeaderFilter,
  //Lookup,
  Editing,
  Selection,
  //Summary,
  //GroupItem,
  //TotalItem,
  SearchPanel,
  Toolbar,
  //Item
} from 'devextreme-react/data-grid';

import {Button as ToolbarButton} from 'devextreme-react/button';
import { Item } from 'devextreme-react/form';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

import { CheckBox } from 'devextreme-react/check-box';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_ScadenzarioFornitori';
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineFornitoreDettaglios';

//export default function SupplierStatus(props) {
export default function SupplierStatus({ commessaFilter, intermediarioFilter },props) {

    const [commesse, setCommesse] = useState({});
    const [intermediari, setIntermediari] = useState({});

    var statusSupplierDataGridRef = React.createRef();
    //const [selectedIndex, setSelectedIndex] = useState(0);

    const [currentRow, setCurrentRow] = useState(1);
    const [isRowSelected, setIsRowSelected] = useState(false);

    // const [intermediarioFilter, setIntermediarioFilter] = useState(210);
    // const [commessaFilter, setCommessaFilter] = useState();

    const [internoFilter, setInternoFilter] = useState(false);

    const editorOptions = { readonly: true, format: '#,##0.00'};

    const { user } = useAuth(); 

    if (!user) 
      Logout();

    const filterPayload = { 
        commessa: commessaFilter,
        intermediario: intermediarioFilter,
        interno: internoFilter
    };

  const remoteDataSourceStatus = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    updateUrl:serviceUrl2 + '/UpdateAction',

  });

  useEffect(() => {
    if (statusSupplierDataGridRef?.instance) {
      statusSupplierDataGridRef.instance().refresh();
    }
  }, [commessaFilter, intermediarioFilter]);

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse';
    var newUrl1 =  newServiceUrl1 + "/GetOpen";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const fetchData = async () => {
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response1 = await fetch(newUrl1,requestOptions);
        const json1 = await response1.json();
        //console.log(json1);
        setCommesse(json1);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        //console.log(json7);
        setIntermediari(json7);

      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);

  const onCellPreparedGrid = (e) => {
    
    if (e.rowType === "data") {
      if (e.column.dataField === "dataConsegna") 
      { 
        var dataConsegna = e.data.dataConsegna;
        var dataEvasione = e.data.dataEvasione;

        if ((dataEvasione !== null))
        {
          e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
        }
        else if (dataConsegna < TodayFormatted())
        {
          e.cellElement.style.cssText = "color: red; font-weight: bold";
        }
        else if ((dataConsegna < SevenDaysFormatted()) &&  (dataConsegna > TodayFormatted()) )
        {
            e.cellElement.style.cssText = "color: orange; font-weight: bold";
        }
      
      }
    }

  }

  // const selectBoxOptions = {
  //   width: 200,
  //   items: commesse,
  //   valueExpr: 'id',
  //   displayExpr: 'nomeEsteso',
  //   placeholder:"<Commessa>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setCommessaFilter(args.value);
  //   },
  //   value: commessaFilter
  // };

  // const selectBoxOptions2 = {
  //   width: 210,
  //   items: intermediari,
  //   valueExpr: 'id',
  //   displayExpr: 'ragioneSociale',
  //   placeholder:"<Azienda>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setIntermediarioFilter(args.value);
  //   },
  //   value: intermediarioFilter,
  // };

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data !== null && data !== undefined) {
      setCurrentRow(data.commessaId);
      setIsRowSelected(true);
    } else{
      setIsRowSelected(false);
    }
    
  }

  function updateMovs() {
    let result = confirm("<i>Aggiornare i Pagamenti della commessa selezionata?</i>", "Aggiorna Pagamenti");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow,1);
      }  
    });
  };

  const aggiornaMovimenti= (idCommessa, mode) => {
      
    var path = "";
    if(mode === 1)
      path = '/api/Commessa/UpdatePaymentMovements/';
    else if(mode === 2)
      path = '/api/Commessa/UpdateProceedsMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idCommessa;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function onCheckValueChanged(e)  {
    setInternoFilter(e.value);
  };

  const hideEditButton = useCallback((e) => {
    return e.row.data.statoOrdineId !== 3;
  }, []);

return (

  <DataGrid
    dataSource={remoteDataSourceStatus}
    focusedRowEnabled={true}
    onSelectionChanged={onRowSelectionChanged}
    onCellPrepared={onCellPreparedGrid}
    dateSerializationFormat= {'yyyy-MM-dd'}
    ref={ref => statusSupplierDataGridRef = ref}
  >
      <SearchPanel visible={true} width={240} placeholder="Cerca..." />
      <HeaderFilter visible={true} />
      <Selection mode="single" />
      <Toolbar>
      <Item location="before">
          <ToolbarButton className="offer-toolbar"
            icon='showpanel'
            hint='Aggiorna Pagamenti'
            onClick={updateMovs} 
            disabled={!isRowSelected}
          />
        </Item>
        <Item location="after">
          <CheckBox  
            value={internoFilter} onValueChanged={onCheckValueChanged}
            defaultValue={internoFilter}
            text="  Escludi Interni   "
          >
          </CheckBox>
        </Item> 

        <Item name="searchPanel" className="offer-toolbar"/>

      </Toolbar>
      <Editing
        mode="popup"
        useIcons={true}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={true}     
      >

        <Popup   title= "&nbsp;&nbsp;&nbsp;Consegna " showTitle={true} width={800} height={625} />
         
        <Form>
          <Item itemType="group" caption="" colCount={2} colSpan={2}>
             
            <Item dataField="commessa" colSpan={2} />
            <Item dataField="ordine" />  
            <Item dataField="fornitore" />  
            <Item dataField="descrizione" colSpan={2} />    
            <Item dataField="importo" editorOptions={editorOptions}/>
            <Item dataField="dataContratto" editorType="dxDateBox" /> 
            <Item dataField="dataConsegna" editorType="dxDateBox" /> 
            <Item dataField="dataEvasione" editorType="dxDateBox" /> 
            <Item dataField="note" colSpan={2} editorType="dxTextArea"/>  
          </Item> 
        </Form>
      </Editing>

      <Column dataField="id" caption="#" width={40} visible={true} allowEditing={false} allowHeaderFiltering={true}/>
      <Column dataField="commessa" allowEditing={false} width={400} groupIndex={0}/>
      <Column dataField="ordine" caption="Ordine" allowEditing={false}/>
      <Column dataField="fornitore"  allowEditing={false}/>
      <Column dataField="descrizione" width={400} allowHeaderFiltering={false} allowEditing={false}/>
      <Column dataField="importo" allowHeaderFiltering={false} allowEditing={false}>
        <Format type="fixedPoint" precision={2} />
      </Column>
      <Column dataField="dataContratto" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true}/>
      <Column dataField="dataConsegna" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true}/>
      <Column dataField="dataEvasione" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true}/>
      <Column dataField="note" visible={true} allowHeaderFiltering={false} width={25} caption="Note"/>
      <Column type="buttons">
        <Button name="edit" visible={hideEditButton} />
      </Column>

    </DataGrid>  
  )
};